<template>
  <div class="container question" style="padding-top:20px;">
    <div class="wrapper">
      <!-- <div class="header">
        Creatable
      </div> -->
      <ul class="main">
        <li data-pos="1" class="type-1">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Alternative scenarios.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span class="boxhead a">Alternative Scenarios</span>
          </a>
        </li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty">
          <button @click="showDialog = true" class="btn noborder">
            <img
              src="../assets/info-trans.jpeg"
              class="img img-responsive"
              width="32"
            />
          </button>
        </li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li
          data-pos="2"
          style="background: linear-gradient(to right, #0099ff, #bd8888)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Bullet proofing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Bulletproof</span>
          </a>
        </li>

        <!-- ROW 2 -->

        <li data-pos="3" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Logical levels.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Logical Levels</span>
          </a>
        </li>
        <li data-pos="4" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Dimensional analysis.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Dimensional Analysis</span>
          </a>
        </li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li data-pos="5" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Analogies.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Analogies</span>
          </a>
        </li>
        <li data-pos="6" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Attribute listing (and variants).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Attribute Listing and variants</span>
          </a>
        </li>
        <li data-pos="7" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Brain sketching.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Brain sketching</span>
          </a>
        </li>
        <li
          data-pos="8"
          style="background: linear-gradient(to right, #6fd196, #97b2d6)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Component detailing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Component Detailing</span>
          </a>
        </li>

        <li
          data-pos="9"
          style="background: linear-gradient(to right, #6fd196, #97b2d6)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Mind-mapping.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Mind mapping</span>
          </a>
        </li>

        <li
          data-pos="10"
          style="background: linear-gradient(to right, #0099ff, #bd8888)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Help, hinder.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Help, hinder</span>
          </a>
        </li>

        <!-- ROW 3 -->

        <li data-pos="11" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Rich pictures.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Rich pictures</span>
          </a>
        </li>
        <li data-pos="12" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Strategic options development and analysis (SODA).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>SODA</span>
          </a>
        </li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li data-pos="13" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Brainwriting game.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Brain Writing Game</span>
          </a>
        </li>
        <li data-pos="14" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Cliches, proverbs and maxims.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Cliches, preverbs and maxims</span>
          </a>
        </li>
        <li data-pos="15" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Exaggeration (magnify or minify).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Exaggeration (magnify or minify)</span>
          </a>
        </li>

        <li
          data-pos="16"
          style="background: linear-gradient(to right, #97b2d6, #0099ff)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Highlighting.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Highlighting</span>
          </a>
        </li>

        <li data-pos="17" class="type-6 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Anonymous voting.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Anonymous Voting</span>
          </a>
        </li>

        <li
          data-pos="18"
          style="background: linear-gradient(to right, #0099ff, #bd8888)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Implementation checklists.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Implement-ation Checklists</span>
          </a>
        </li>

        <!-- ROW 4 -->

        <li data-pos="19" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Soft systems method.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Soft Systems Method</span>
          </a>
        </li>
        <li data-pos="20" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Strategic assumption testing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Strategic Assumption Testing</span>
          </a>
        </li>
        <li
          data-pos="21"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Imagery for answering questions.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Imagery for answering questions</span>
          </a>
        </li>
        <li
          data-pos="22"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Itemised response.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Itemised response</span>
          </a>
        </li>

        <li
          data-pos="23"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Browsing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Browsing</span>
          </a>
        </li>
        <li
          data-pos="24"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Bug listing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Bug Listing</span>
          </a>
        </li>
        <li
          data-pos="25"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Essay writing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Essay Writing</span>
          </a>
        </li>
        <li
          data-pos="26"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Free association.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Free Association</span>
          </a>
        </li>

        <li
          data-pos="27"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497, #97b2d6, #9f92af)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Card story-board.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Card Story Boards</span>
          </a>
        </li>
        <li
          data-pos="28"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497, #0099ff)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Charrette.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Charrette</span>
          </a>
        </li>

        <li data-pos="29" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Kepner Tregoe.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Kepner Tregoe</span>
          </a>
        </li>
        <li data-pos="30" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Clarification.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Clarification</span>
          </a>
        </li>
        <li data-pos="31" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Excursions.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Excursions</span>
          </a>
        </li>
        <li data-pos="32" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Laddering.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Laddering</span>
          </a>
        </li>
        <li data-pos="33" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Heuristic ideation technique (HIT).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Heuristic Ideation Technique</span>
          </a>
        </li>

        <li
          data-pos="34"
          style="background: linear-gradient(to right, #97b2d6, #0099ff)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Analysis of interactive decision areas (AIDA).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>AIDA</span>
          </a>
        </li>
        <li data-pos="35" class="type-6 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Dialectical approaches.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Dialtectical Approaches</span>
          </a>
        </li>
        <li
          data-pos="36"
          style="background: linear-gradient(to right, #0099ff, #bd8888)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Negative brainstorming.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Negative Brain Storming</span>
          </a>
        </li>

        <!-- ROW 5 -->

        <li data-pos="37" class="type-1 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Time line.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Time Line</span>
          </a>
        </li>
        <li
          data-pos="38"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Assumption surfacing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Assumption Surfacing</span>
          </a>
        </li>
        <li
          data-pos="39"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Multiple redefinition.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Multiple redfinition</span>
          </a>
        </li>
        <li
          data-pos="40"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Reframing values.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Reframing Values</span>
          </a>
        </li>

        <li
          data-pos="41"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Crawford slip writing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Crawford Slip Writing</span>
          </a>
        </li>
        <li
          data-pos="42"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Delphi.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Delphi</span>
          </a>
        </li>
        <li
          data-pos="43"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Fresh eye and networking.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Fresh eye and networking</span>
          </a>
        </li>
        <li
          data-pos="44"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Gallery method.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Gallery method</span>
          </a>
        </li>
        <li
          data-pos="45"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497, #0099ff)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Metaplan information market.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Metaplan information market</span>
          </a>
        </li>
        <li
          data-pos="46"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497, #0099ff)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Receptivity to ideas.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Receptivity to ideas</span>
          </a>
        </li>

        <li data-pos="47" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Paraphrasing key words.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Paraphrasing key words</span>
          </a>
        </li>
        <li data-pos="48" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Value engineering.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Value Engineering</span>
          </a>
        </li>
        <li data-pos="49" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Improved nominal group technique.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Nominal Group Technique</span>
          </a>
        </li>
        <li data-pos="50" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Osborns checklist.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Osborn's Checklist</span>
          </a>
        </li>
        <li data-pos="51" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Quota.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Quota</span>
          </a>
        </li>

        <li
          data-pos="52"
          style="background: linear-gradient(to right, #97b2d6, #0099ff)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Paired comparison.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Paired Comparison</span>
          </a>
        </li>
        <li data-pos="53" class="type-6 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Simple rating methods.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Simple Rating Methods</span>
          </a>
        </li>
        <li data-pos="54" class="type-8 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Critical path diagrams.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Critical Path Diagram</span>
          </a>
        </li>

        <!-- ROW 6 -->

        <li
          data-pos="55"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Boundary examination.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Boundary Examination</span>
          </a>
        </li>
        <li
          data-pos="56"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Boundary relaxation.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Boundary Relaxation</span>
          </a>
        </li>
        <li
          data-pos="57"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Search conference.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Search Conference</span>
          </a>
        </li>
        <li
          data-pos="58"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Sleight of mouth.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Sleight of mouth</span>
          </a>
        </li>

        <li
          data-pos="59"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Keeping a dream diary.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Dream Diary</span>
          </a>
        </li>
        <li
          data-pos="60"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Notebook.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Notebook</span>
          </a>
        </li>
        <li
          data-pos="61"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Greetings cards.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Greetings cards</span>
          </a>
        </li>
        <li
          data-pos="62"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Imagery manipulation.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Imagery Manipulation</span>
          </a>
        </li>
        <li
          data-pos="63"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497, #97b2d6, #9f92af)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Five Ws and H.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>5 Ws & H</span>
          </a>
        </li>
        <li
          data-pos="64"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497, #97b2d6, #9f92af)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Drawing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Drawing</span>
          </a>
        </li>

        <li data-pos="65" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/CATWOE.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>CATWOE</span>
          </a>
        </li>
        <li data-pos="66" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Other peoples definitions.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Other Peoples Definitions</span>
          </a>
        </li>
        <li data-pos="67" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Reversals.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Reversals</span>
          </a>
        </li>
        <li data-pos="68" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Rolestorming.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Role storming</span>
          </a>
        </li>
        <li data-pos="69" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Sculptures.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Sculptures</span>
          </a>
        </li>

        <li data-pos="89" class="type-6 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Idea advocate.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Idea Advocate</span>
          </a>
        </li>
        <li data-pos="71" class="type-6 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Estimate discuss estimate.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Estimate, Discuss, Estimate</span>
          </a>
        </li>
        <li data-pos="72" class="type-8 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Factors in selling ideas.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Factors in selling ideas</span>
          </a>
        </li>

        <!-- ROW 7 -->

        <li
          data-pos="73"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Gap analysis.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Gap Analysis</span>
          </a>
        </li>
        <li
          data-pos="74"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Goal orientation.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Goal Orientation</span>
          </a>
        </li>
        <li
          data-pos="75"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Value brainstorming.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Value Brainsorming</span>
          </a>
        </li>
        <li
          data-pos="76"
          style="background: linear-gradient(to right, #fc676c, #eca671)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Who are you.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Who are you</span>
          </a>
        </li>

        <li
          data-pos="77"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Repeatable questions.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Repeatable questions</span>
          </a>
        </li>
        <li
          data-pos="78"
          style="background: linear-gradient(to right, #fc676c, #eca671, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/KJ-method.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>KJ Method</span>
          </a>
        </li>
        <li
          data-pos="79"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Story writing.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Story writing</span>
          </a>
        </li>
        <li
          data-pos="80"
          style="background: linear-gradient(to right, #fc676c, #bde497)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Progressive revelation.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Progressive Revelation</span>
          </a>
        </li>
        <li
          data-pos="81"
          style="background: linear-gradient(to right, #fc676c, #97b2d6)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Fishbone diagram.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Fishbone Diagram</span>
          </a>
        </li>
        <li
          data-pos="82"
          style="background: linear-gradient(to right, #fc676c, #97b2d6)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Causal mapping.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Causal Mapping</span>
          </a>
        </li>

        <li data-pos="83" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Visualising a goal.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Visualising a Goal</span>
          </a>
        </li>
        <li data-pos="84" class="type-3 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Criteria for idea-finding potential.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Criteria for idea-finding potential</span>
          </a>
        </li>
        <li data-pos="85" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Semantic intuition.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Semantic Inuiition</span>
          </a>
        </li>
        <li data-pos="86" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Super heroes.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Super Heroes</span>
          </a>
        </li>
        <li data-pos="87" class="type-4 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Using crazy ideas.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Crazy ideas</span>
          </a>
        </li>

        <li data-pos="88" class="type-6 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Progressive hurdles.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Progressive Hurdles</span>
          </a>
        </li>
        <li
          data-pos="89"
          style="background: linear-gradient(to right, #97b2d6, #0099ff, #bd8888)"
        >
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Consensus mapping.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Consensus mapping</span>
          </a>
        </li>

        <li data-pos="90" class="type-8 cat-0">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Potential problem analysis (PPA).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Potential Problem Analysis</span>
          </a>
        </li>

        <!-- // ROW 8 -->
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li data-pos="91" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Controlling imagery.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Controlling Imagery</span>
          </a>
        </li>
        <li data-pos="92" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Decision seminar.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Decision seminar</span>
          </a>
        </li>
        <li data-pos="93" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Disney.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Disney</span>
          </a>
        </li>
        <li data-pos="94" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/McKims method.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>McKims Method</span>
          </a>
        </li>
        <li data-pos="95" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Observer and merged viewpoints.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Observer & merged viewpoints</span>
          </a>
        </li>
        <li data-pos="96" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Phases of integrated problem solving (PIPS).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>PIPS</span>
          </a>
        </li>
        <li data-pos="97" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Problem centred leadership (PCL).pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Problem Centred Leadership</span>
          </a>
        </li>
        <li data-pos="98" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Quality circles.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Quality circles</span>
          </a>
        </li>
        <li data-pos="99" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Strategic choice approach.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Strategic Choice Approach</span>
          </a>
        </li>
        <li data-pos="100" class="type-10">
          <a
            href="https://comscientia.com/training_course_examples/ctl/pages/Strategic management process.pdf"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Strategic Management Process</span>
          </a>
        </li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>

        <li data-pos="Ext 1" class="type-9">
          <a
            href="https://en.wikipedia.org/wiki/AXELOS"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>P3O - Waterfall</span>
          </a>
        </li>
        <li data-pos="Ext 2" class="type-9">
          <a
            href="http://agilemanifesto.org/"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Agile</span>
          </a>
        </li>
        <li data-pos="Ext 3" class="type-9">
          <a
            href="https://servicedesigntools.org"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Service Design</span>
          </a>
        </li>
        <li data-pos="Ext 4" class="type-9">
          <a
            href="https://www.scaledagileframework.com/"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>SAFe</span>
          </a>
        </li>
        <li data-pos="Ext 5" class="type-9">
          <a
            href="https://teamtopologies.com/"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Team Topologies</span>
          </a>
        </li>
        <li data-pos="Ext 6" class="type-9">
          <a
            href="https://less.works/"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>LESS</span>
          </a>
        </li>
        <li data-pos="Ext 7" class="type-9">
          <a
            href="https://en.wikipedia.org/wiki/DevOps"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>DevOps</span>
          </a>
        </li>
        <li data-pos="Ext 8" class="type-9">
          <a
            href="https://svpg.com"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>SVPG</span>
          </a>
        </li>

        <li data-pos="Ext 9" class="type-9">
          <a
            href="https://timeandemotion.com/leanscenes"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Lean Scenes</span>
          </a>
        </li>
        <li data-pos="Ext 10" class="type-9">
          <!-- <a href="https://strategyzer.com/" style="text-decoration:none;" target="_blank"> -->
          <a
            href="https://platform.strategyzer.com/vpd"
            style="text-decoration:none;"
            target="_blank"
          >
            <span>Strategyzer</span>
          </a>
        </li>

        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
        <li class="empty"></li>
      </ul>

      <div class="legend">
        <img
          src="../assets/atoms-raw-crop.png"
          width="350px"
          class="img img-responsive"
        />
      </div>
    </div>
    <!-- End TABLE -->
    <Dialogue
      :show="showDialog"
      :cancel="cancel"
      :confirm="confirm"
      title="Creatable"
      description="Instructions"
    />
  </div>
</template>

<script>
import Dialogue from "./Dialogue.vue";

export default {
  name: "PeriodicTable",
  components: {
    Dialogue,
  },

  data() {
    return {
      showDialog: false,
      showDialogUser: false,
    };
  },
  methods: {
    cancel() {
      // eslint-disable-next-line no-console
      console.log("cancel");
      this.showDialog = false;
      this.showDialogUser = false;
    },

    confirm() {
      // eslint-disable-next-line no-console
      console.log("confirm");
      this.showDialog = false;
    },

    confirmUser() {
      // console.log('confirm user');

      this.showDialogUser = false;
    },
  },
};
</script>

<style>
.header {
  width: 100px;
  text-align: left;
  font-size: 2em;
  font-weight: 800;
  height: 30px;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.xyz {
  background-size: auto;
  text-align: center;
  padding-top: 100px;
}
.btn-circle.btn-sm {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  font-size: 8px;
  text-align: center;
}
.btn-circle.btn-md {
  width: 50px;
  height: 50px;
  padding: 7px 10px;
  border-radius: 25px;
  font-size: 10px;
  text-align: center;
  background-color: lightskyblue;
}
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 12px;
  text-align: center;
}
.ImageBorder {
  border-style: solid;
  border-width: 1px;
  border-color: Black;
}

.contact-form {
  font-family: 16px;
  /* margin: 0 auto; */
  max-width: 600px;
  width: 100%;
}

.contact-form .separator {
  border-bottom: solid 1px #ccc;
  margin-bottom: 15px;
}

.contact-form .form {
  display: flex;
  flex-direction: column;
  font-size: 16px;
}

.contact-form_title {
  color: #333;
  text-align: left;
  font-size: 28px;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea {
  border: solid 1px #e8e8e8;
  font-family: "Roboto", sans-serif;
  padding: 10px 7px;
  margin-bottom: 15px;
  outline: none;
}

.contact-form textarea {
  resize: none;
}

.contact-form .button {
  background: #da552f;
  border: solid 1px #da552f;
  color: white;
  cursor: pointer;
  padding: 10px 50px;
  text-align: center;
  text-transform: uppercase;
}

.contact-form .button:hover {
  background: #ea532a;
  border: solid 1px #ea532a;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
  font-size: 15px;
  border-radius: 3px;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

body {
  /* background:linear-gradient(#dbeaf8, #dbeaf8); */
  color: #222;
  padding: 20px;
  font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue",
    Helvetica, Arial, "Lucida Grande", sans-serif;
}

.wrapper {
  width: 1050px;
  margin: 30px auto;
  position: relative;
}

.main:after {
  clear: both;
  content: "";
  display: table;
}

.main li {
  width: 56px;
  height: 60px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
  position: relative;
  font-size: 13px;
  float: left;
  padding: 0 2px;
  margin: 1px;
  cursor: pointer;
  padding-top: 20px;
  overflow: hidden;
  transition: all 0.2s ease-in;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);
}
@-moz-document url-prefix() {
  .main li {
    width: 56px;
    height: 60px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
    position: relative;
    font-size: 12px;
    float: left;
    padding: 0 2px;
    margin: 1px;
    cursor: pointer;
    /* padding-top:20px; */
    overflow: hidden;
    transition: all 0.2s ease-in;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);
  }
}
.main li span {
  display: block;
  line-height: 1;
  font-size: 9px;
  font-weight: 500;
  color: black;
  padding-top: 7px;
}

.main .empty {
  border: none;
  box-shadow: none;
  cursor: default;
}

.deactivate {
  opacity: 0.5;
  -webkit-filter: grayscale(70%);
  filter: grayscale(70%);
}

.main li:before,
.main li:after {
  content: attr(data-pos);
  position: absolute;
  top: 3px;
  left: 3px;
  color: black;
  font-size: 8px;
  line-height: 1;
}

.main li:after {
  content: attr(data-nb);
  left: auto;
  right: 3px;
}

.main li:hover {
  transform: scale(2);
  z-index: 100;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  font-size: 9px;
}

.main .empty:hover {
  box-shadow: none;
  transform: none;
}

/* .type-0 { background:#fff; } */
.type-1 {
  background: #fc676c;
}
.type-2 {
  background: #eca671;
}
.type-3 {
  background: #e0e36d;
}
.type-4 {
  background: #bde497;
}
.type-5 {
  background: #6fd196;
}
.type-6 {
  background: #97b2d6;
}
.type-7 {
  background: #9f92af;
}
.type-8 {
  background: #bd8888;
}
.type-9 {
  background: grey;
}
.type-10 {
  background: #999999;
}

.cat-0 {
  color: #222;
}
.cat-1 {
  color: #0000dc;
}
.cat-2 {
  color: #b10601;
}
.cat-3 {
  color: #555;
}

.legend {
  position: absolute;
  top: 0;
  left: 20%;
  padding: 10px;
  font-size: 11px;
  background: #f1edec;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  box-shadow: inset 0 1px 1px white, inset 0 -5px 3px #dddcdb,
    0 0 10px rgba(0, 0, 0, 0.2);
}

.legend:after {
  content: "";
  display: table;
  clear: table;
}

.legend ul {
  float: left;
  list-style: none;
}

.legend .list-2 {
  margin-left: 40px;
  width: 300px;
}

.legend .list-1 li {
  margin: 7px 0;
}
.legend .list-1 li:first-of-type {
  margin-top: 2px;
}

.legend .list-1 span {
  border: 1px solid black;
  display: inline-block;
  padding: 3px;
  width: 20px;
  text-align: center;
  height: 20px;
  margin-right: 5px;
}

.legend .list-2 li {
  margin: 2px;
  padding: 3px;
  float: left;
  border: 1px solid rgba(0, 0, 0, 0.2);
  width: 48%;
  cursor: pointer;
}
.table-title {
  padding-bottom: 40px;
  padding-top: 40px;
}
.noborder {
  padding: 0;
  border: none;
  background: none;
}
</style>
